import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStyles, translate } from '../../../../shared/utility';

import Button from '../../../UI/Button/Button';
import Input from '../../../UI/Input/Input';
import Dots from '../../../UI/Loading/Dots/Dots';
import Icon from '../../../UI/Icon/Icon';

import localStyles from './SearchToggles.scss';
const styles = getStyles(localStyles);

const searchToggles = (props) => {
    const toggleItems = props.mainTypesData.map((item, index) => (
        <li key={index} className={styles('types__item')}>
            <Input
                attrs={{
                    type: 'checkbox',
                    name: 'topSearchMainItemType'
                }}
                value={item.id}
                checked={!!props.activeMainType && props.activeMainType.id === item.id}
                modifiers={['button']}
                events={{
                    change: () => props.toggleMainItemType(item.id)
                }}
                label={item.name}
            />
        </li>
    ));
    const typeToggles = toggleItems.length ? (
        <Fragment>
            <h6>{translate('toolbar.searchbar.types.title', props.language)}</h6>
            <ul className={styles('types', 'no-list-style')}>
                {toggleItems}
            </ul>
        </Fragment>
    ) : null;

    const currentLocation = props.currentLocationAvailable ? (
        <Fragment>
            <h6 className={styles('search-section__title')}>{translate('toolbar.searchbar.currentLocation.title', props.language)}</h6>
            <ul className={styles('search-section', 'no-list-style')}>
                <li className={styles('search-section__item')}>
                    <Button
                        modifiers={['text', 'stretch']}
                        classes={styles('search-section__item__button')}
                        events={{
                            click: props.activateCurrentLocation
                        }}
                        disabled={props.currentLocationLoading}
                    >
                        <Icon icon={'location'} modifiers={['inline']} />
                        <span className={styles('search-section__item__content')}>
                            <span>{translate('toolbar.searchbar.currentLocation.itemName', props.language)}</span>
                            {props.currentLocationLoading ? <Dots classes={styles('search-section__item__dots')} /> : null}
                        </span>
                    </Button>
                </li>
            </ul>
        </Fragment>
    ) : null;
    const historyItems = props.historyItems.slice(
        (!props.activeSearchLocation ? -5 : -6),
        (!props.activeSearchLocation ? props.historyItems.length : -1)
    )
        .map((item, index) => (
            <li key={index} className={styles('search-section__item')}>
                <Button
                    modifiers={['text', 'stretch']}
                    classes={styles('search-section__item__button')}
                    events={{ click: () => props.activateHistoryItem(item) }}
                >
                    <Icon icon={'time'} modifiers={['inline']} />
                    <span className={styles('search-section__item__content')}>
                        {item.id === 'CURRENT_LOCATION' ?
                            translate('toolbar.searchbar.currentLocation.tagValue', props.language) :
                            item.value
                        }
                    </span>
                </Button>
            </li>
        )).reverse();

    const searchHistory = historyItems.length ? (
        <Fragment>
            <h6 className={styles('search-section__title')}>{translate('toolbar.searchbar.history.title', props.language)}</h6>
            <ul className={styles('search-section', 'no-list-style')}>
                {historyItems}
            </ul>
        </Fragment>
    ) : null;

    return (
        <Fragment>
            {typeToggles}
            {currentLocation}
            {searchHistory}
        </Fragment>
    );
};

searchToggles.propTypes = {
    // properties
    historyItems: PropTypes.arrayOf(PropTypes.object).isRequired,

    activeSearchLocation: PropTypes.object,
    currentLocationAvailable: PropTypes.bool.isRequired,
    currentLocationLoading: PropTypes.bool.isRequired,

    activeMainType: PropTypes.object,
    mainTypesData: PropTypes.arrayOf(PropTypes.object).isRequired,

    language: PropTypes.string.isRequired,

    // functions
    toggleMainItemType: PropTypes.func.isRequired,
    activateHistoryItem: PropTypes.func.isRequired,
    activateCurrentLocation: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        activeSearchLocation: state.global.activeSearchLocation,
        currentLocationAvailable: state.global.currentLocationAvailable,
        currentLocationLoading: state.details.currentLocation.loading,

        activeMainType: state.global.activeMainType,
        mainTypesData: state.list.mainTypes.data,

        language: state.global.localization.language
    };
};

export default connect(mapStateToProps, null)(searchToggles);



// WEBPACK FOOTER //
// ./src/components/Navigation/SearchFocus/SearchToggles/SearchToggles.js